import { Divider, IconButton, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import React from 'react';
import Theme from '../../../Themes/main.theme';
import LaunchIcon from '@mui/icons-material/Launch';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import TableGridWithFilters from '../../../components/TablegridWithFilters/TableGridWithFilters/TableGridWithFilters';
import { createSearchParamsFormat } from '../../../lib/helperFuncs';
import { FieldControllerTypes } from '../../../components/form_v2/types';

const _initialValues = {
  foreas: '',
  description: '',
};

function Foreas() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const matchesXSbreakpoint = useMediaQuery('(max-width:768px)');
  const [initialValues, setInitialValues] = React.useState(_initialValues);

  const [searchParams, setSearchParams] = useSearchParams();
  const [fetchUrl, setFetchUrl] = React.useState<string>(`${process.env.REACT_APP_BACKEND_URL}/foreas?is_public=1&${searchParams.toString()}`);
  
  document.title= t('Αναζήτηση Οπτικοακουστικών Φορέων'); 

  const fullScreen = [
    [{
      control: FieldControllerTypes.input,
      label: t('Ονομασία Φορέα'),
      type: 'search',
      customLabel: true,
      name: 'foreas',
      id: 'foreas',
      filtersDesign: true,
    },
    {
      control: FieldControllerTypes.input,
      label: t('Περιγραφή Συλλογών'),
      type: 'search',
      customLabel: true,
      name: 'description',
      id: 'description',
      filtersDesign: true,
    }]
  ];

  const mobileFilters = [
    [{
      control: FieldControllerTypes.input,
      label: t('Ονομασία Φορέα'),
      type: 'search',
      customLabel: true,
      name: 'foreas',
      id: 'foreas',
      filtersDesign: true,
    }],
    [{
      control: FieldControllerTypes.input,
      label: t('Περιγραφή Συλλογών'),
      type: 'search',
      customLabel: true,
      name: 'description',
      id: 'description',
      filtersDesign: true,
    }]
  ];
  
  const columns: GridColDef[] = [
    {
      field: 'organisations:organisationsName',
      headerName: t('Ονομασία Φορέα στα Ελληνικά') || undefined,
      minWidth: 680,
      renderCell: ({row}) => row['organisations:organisationsName'][0]['@value']

    },
    {
      field: 'organisations:organisationsEnNameEn',
      headerName: t('Ονομασία Φορέα στα Αγγλικά') || undefined,
      minWidth: 680,
      renderCell: ({row}) => row['organisations:organisationsEnNameEn']?.[0]?.['@value'] || '-'
    },
    {
      field: 'info',
      headerName: t('Λεπτομέρειες') || undefined ,
      minWidth: 155,
      sortable: false,
      renderCell: ({row}) => 
        <Tooltip PopperProps={{
          disablePortal: true
        }}
        title={t('Προβολή')}>
          <IconButton onClick={() => navigate(`/search-organisation/details/${row['o:id']}`)}>
            <LaunchIcon color='primary'/></IconButton>
        </Tooltip>
    },

  ];

  const onSubmit = (values: any) => {
    const x = createSearchParamsFormat(values);
    Object.keys(initialValues).map((value) => {
      searchParams.delete(value);
      setSearchParams(searchParams);
    });
    setFetchUrl(`${process.env.REACT_APP_BACKEND_URL}/foreas?${searchParams.toString()}&${createSearchParams(x).toString()}`);
    setSearchParams(`${searchParams.toString()}&${createSearchParams(x).toString()}`);
  };

  // useEffect for initialValues of filters based on searchParams
  React.useEffect(() => {
    let _params = { ..._initialValues };
    for (const entry of searchParams.entries()) {
      const [param, value] = entry;
      if (searchParams.has(param) && param in _initialValues) {
        _params = { ..._params, [param]: value };
      }
    }
    setInitialValues({ ..._params });
  }, []);
  
  return (
    <>
      <Typography sx={{my: 2}} variant='h2'
        color={Theme?.labelColor?.main}>{t('Αναζήτηση Οπτικοακουστικών Φορέων')}</Typography>
      <Divider sx={{mb: 5, border: 1, color: Theme?.dividerColor?.main}}/>
      <TableGridWithFilters
        responseDataFieldName='data'
        responseTotalCountFieldName = 'totalResults'
        sortingMode='server'
        paginationMode='server'
        pageSize={15}
        rowsPerPageOptions={[15, 30, 45]}
        initialValues={initialValues}
        filterFields={matchesXSbreakpoint
          ? mobileFilters
          : fullScreen}
        columns={columns}
        hidePagination={true}
        resetFilters={true}
        onFiltersChange={filterValues => onSubmit(filterValues)}
        fetchUrl={fetchUrl}
        ignoreFilters
      />
    </>
  );
}

export default Foreas;